package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetSessionKeywordsResponse(
    val data: List<GetSessionKeywordsData>
)

@Serializable
data class GetSessionKeywordsData(
    @SerialName("_attachments")
    val attachments: String = "",
    @SerialName("_etag")
    val etag: String = "",
    @SerialName("_rid")
    val rid: String = "",
    @SerialName("_self")
    val self: String = "",
    @SerialName("_ts")
    val timestamp: Long = 0,
    val domainType: String = "",
    val id: String = "",
    val keyWordType: String = "",
    val keywordCategory: String = "",
    val language: String = "",
    val organization: String = "",
    val sessionDateTime: String = "",
    @SerialName("sessionID")
    val sessionId: String = "",
    val sessionType: String = "",
    val text: String = "",
    val type: String = "",
    val usageCount: Int = 0,
    @SerialName("userID")
    val userId: String = ""
)